import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/eventos/azierta-se-integra-por-completo-en-qbd-group")({
  head: () => buildRouteHead("/es/eventos/azierta-se-integra-por-completo-en-qbd-group", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/sobre-qbd/historia", replace: true });
  },
});
